import { useRef } from 'react';
import { BLOQUE0_PAGINA2, BLOQUE0_PAGINA3, BLOQUES } from '@cessi/content';
import { Boton } from '../ui';
import { FRAMEWORK_SELLO } from '../lib/framework';
import { BrandLockup } from './BrandLockup';
import { RadarPreview } from './RadarChart';

type Props = {
  intro: string;
  onStart: () => void;
};

const N_CONTEXTO = BLOQUE0_PAGINA2.length + BLOQUE0_PAGINA3.length;
const N_MADUREZ = BLOQUES.reduce((n, b) => n + b.preguntas.length, 0);

export const PASOS = [
  {
    titulo: 'Su contexto',
    detalle: `${N_CONTEXTO} preguntas breves para ubicar a la organización.`,
  },
  {
    titulo: 'Su madurez',
    detalle: `${N_MADUREZ} preguntas sobre las cuatro dimensiones, la gobernanza y la innovación, una por pantalla. No hay respuestas correctas.`,
  },
  {
    titulo: 'Su perfil',
    detalle: 'Radar de madurez, índice de innovación y próximos pasos.',
  },
];

export function Landing({ intro, onStart }: Props) {
  const detalleRef = useRef<HTMLElement>(null);

  const irADetalle = () => {
    const suave =
      typeof window !== 'undefined' &&
      typeof window.matchMedia === 'function' &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    detalleRef.current?.scrollIntoView({ behavior: suave ? 'smooth' : 'auto', block: 'start' });
    detalleRef.current?.focus({ preventScroll: true });
  };

  return (
    <>
      <BrandLockup conTitulo={false} subtitulo={FRAMEWORK_SELLO} conSolapas />
      <main className="landing">
        <section className="landing__hero" aria-labelledby="landing-titulo">
          <div className="landing__copy">
            <p className="eyebrow">
              Autoevaluación de Adopción e Innovación con inteligencia artificial · CESSI
            </p>
            <h1 id="landing-titulo" className="landing__headline">
              ¿Hasta dónde llegó su organización con la inteligencia artificial?
            </h1>
            <p className="landing__intro">
              Diagnóstico de madurez en IA para organizaciones socias de CESSI: perfil por
              dimensión y tres capacidades para los próximos 90 días.
            </p>
            <div className="acciones landing__cta">
              <Boton variante="primario" tamano="grande" onClick={onStart}>
                Comenzar autoevaluación
              </Boton>
              <Boton variante="secundario" tamano="grande" onClick={irADetalle}>
                Cómo funciona
              </Boton>
            </div>
            <p className="landing__meta">
              Menos de 20 minutos · Sus respuestas individuales no se publican
            </p>
          </div>

          <div className="landing__ancla" aria-hidden="true">
            <RadarPreview />
          </div>
        </section>

        <section
          className="landing__detalle"
          ref={detalleRef}
          tabIndex={-1}
          aria-labelledby="landing-como"
        >
          <p className="eyebrow">Cómo funciona</p>
          <h2 id="landing-como" className="landing__subtitulo">
            Tres pasos, menos de veinte minutos
          </h2>
          <ol className="landing__pasos">
            {PASOS.map((p, i) => (
              <li className="landing__paso" key={p.titulo}>
                <span className="landing__paso-n" aria-hidden="true">
                  {i + 1}
                </span>
                <h3>{p.titulo}</h3>
                <p>{p.detalle}</p>
              </li>
            ))}
          </ol>
          <div className="landing__pie">
            <p className="landing__nota ayuda">{intro}</p>
            <div className="acciones landing__cta">
              <Boton variante="primario" tamano="grande" onClick={onStart}>
                Comenzar autoevaluación
              </Boton>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}
